import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { fetchApiData } from "../../../redux/reducers/commonApiSlice";
import { memberGet, trainersGet } from "../../../data/ApiEndpoints";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import {
  convertStraight,
  convertTo12HourFormat,
  fixedTwo,
  formattedAmount,
  formattedLongDate2,
} from "../../common-data/Converts";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import MemberCheckinLogs from "../../pt-trials/common/MemberCheckinLogs";
import CmnFilters from "../../lead-management/common/CmnFilters";
import { BodyBuilder } from "../../../exports/Images";
import { CrossCircleIcon } from "../../../images/icons/icons";

const GymMembers = ({ userInfoData, rowData, selectedTab }) => {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.common);

  // const isAdmin = userInfoData?.account_type === "admin";
  // const isGym = userInfoData?.account_type === "gym";

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: {
      label: rowData?.gym_name || "",
      value: rowData?.user_id || "",
    },
    selectedTrainer: "",
    isActive: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    trainer_id: allFilters.selectedTrainer?.value || "",
    status: allFilters.isActive?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);
  const iniModvalues = {
    isModOpen: false,
    userId: "",
    rowData: "",
    modName: "",
    sendableStatsQPs: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  function onCloseModal() {
    setModValues(iniModvalues);
  }

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getDetails(filters, endpoint) {
    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: endpoint,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    if (filters.gym_id) {
      getDetails(
        filters,
        selectedTab === 0 ? memberGet : selectedTab === 1 ? trainersGet : ""
      );
    }
  }, [filters, selectedTab]);

  useEffect(() => {
    if (data?.status && !loading && !error) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: data.data,
        pagination: data?.pagination?.length > 0 ? data.pagination : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      trainer_id: allFilters.selectedTrainer?.value || "",
      status: allFilters.isActive?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selectedTrainer,
    allFilters.isActive,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  const tbColumns = [
    {
      dataField: "user_id",
      text: "Member Info",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.mobile || ""}
              <br />
              {row?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date added",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formattedLongDate2(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "subscription_status",
      text: "subscription status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth100 withPadding borderRdius8"
            style={{
              background:
                row?.subscription_status === "active" ? "#379C00" : "#C80000",
              color: "#fff",
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "member_subscription_details",
                rowData: row,
              }))
            }
          >
            {row?.subscription_status?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "last_checkin",
      text: "Member Last Checkin",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth150 link"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                userId: row?.user_id,
                isModOpen: true,
                modName: "member_checkin_details",
                sendableStatsQPs: `&start_date=${
                  row?.last_checkin || ""
                }&end_date=${row?.last_checkin || ""}`,
              }))
            }
          >
            {convertStraight(row?.last_checkin) || "-"}
            {/* <br />
            {convertTimeRangeHHMMSS(row?.checkin_time) || ""} */}
            <br />
            {row?.last_checkin_days_ago
              ? `(${row.last_checkin_days_ago?.replace(/_/g, " ")})`
              : ""}
          </span>
        );
      },
    },
    {
      dataField: "dob",
      text: "DOB",
      formatter: (cell, row) => {
        return <span className="tb-data minWidth100">{row?.dob || "-"}</span>;
      },
    },
    {
      dataField: "age",
      text: "age",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.age || "-"}</span>;
      },
    },
    {
      dataField: "gender",
      text: "gender",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.gender || "-"}</span>;
      },
    },
    {
      dataField: "weight",
      text: "weight",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {fixedTwo(row?.weight || 0)} KG
          </span>
        );
      },
    },
    {
      dataField: "height",
      text: "height",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {fixedTwo(row?.height || 0)} CM
          </span>
        );
      },
    },
  ];

  const subsTbColumn = [
    {
      dataField: "type",
      text: "Subscription Type",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding minWidth100"
            style={{
              background: row?.one_day_membership
                ? "#cd0909"
                : row?.type === "addon_pt"
                ? "#066CE3"
                : row?.type === "addon"
                ? "#5A56E4"
                : row?.type === "regular"
                ? "#00B295"
                : "#686D76",
              color: "#fff",
              borderRadius: "10px",
            }}
          >
            <small>
              {row?.one_day_membership
                ? "One Day"
                : row?.type === "addon_pt"
                ? "PT"
                : row?.type?.replace(/_/g, " ") || "NA"}
            </small>
          </span>
        );
      },
    },
    // {
    //   dataField: "plan_id",
    //   text: "Plan Name",
    //   formatter: (cell, row) => {
    //     return (
    //       <span
    //         className="tb-data withPadding borderRdius8 minWidth150"
    //         style={{
    //           background:
    //             row?.type === "addon_pt"
    //               ? "#066CE3"
    //               : row?.type === "addon"
    //               ? "#5A56E4"
    //               : row?.type === "regular"
    //               ? "#00B295"
    //               : "#686D76",
    //           color: "#fff",
    //           borderRadius: "10px",
    //         }}
    //       >
    //         <small>
    //           {row?.type === "regular"
    //             ? row?.plan_name
    //             : row?.addon_name || "NA"}
    //         </small>
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "price",
      text: "Price",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{row?.price ? formattedAmount(row.price) : 0}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Subscription Created On",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.date_added ? formattedLongDate2(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "start_date",
      text: "Subscription Start Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.start_date
              ? moment(row.start_date).tz("Asia/Kolkata").format("DD-MM-YYYY")
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "expire_date",
      text: "Subscription Expire Date",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data"
            style={{
              color: "#D32D2D",
              fontWeight: "700",
            }}
          >
            {row?.expire_date
              ? moment(row.expire_date).tz("Asia/Kolkata").format("DD-MM-YYYY")
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "trx_id",
      text: "Transaction ID",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            <small>
              {row?.is_imported === 1
                ? "Import Member"
                : row?.trx_id === "cash"
                ? "Cash"
                : `Online/${row?.trx_id}` || "NA"}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "subscription_status",
      text: "Subscription Status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 minWidth150"
            style={{
              background:
                row?.subscription_status === "active" ? "#379C00" : "#C90808",
              color: "#fff",
            }}
          >
            <small>{row?.subscription_status || "NA"}</small>
          </span>
        );
      },
    },
  ];

  const tbTrainersColumns = [
    {
      dataField: "profile",
      text: "Profile",
      formatter: (_, row) => (
        <div
          className="emeberDetailsRowContainer"
          style={{
            textAlign: "center",
            justifyContent: "flex-start",
            gap: "1rem",
          }}
        >
          <img
            src={row?.profile || BodyBuilder}
            alt={row?.name || "N/A"}
            className="image"
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "4px",
              border: "1px solid #000",
              padding: "10px",
              cursor: "pointer",
            }}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "trainer_profile",
                rowData: row,
                image: row?.profile || BodyBuilder,
              }))
            }
          />
        </div>
      ),
    },
    {
      dataField: "user_id",
      text: "trainer info",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.mobile || ""}
              <br />
              {row?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "date_onboarding",
      text: "date onboarding",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_onboarding ? convertStraight(row.date_onboarding) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "trainer_exp_lvl_name",
      text: "experience level",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">{row?.trainer_exp_lvl_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "trainer_exp_pt",
      text: "PT experience",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.trainer_exp_pt || 0}</span>;
      },
    },
    {
      dataField: "trainer_exp_gt",
      text: "general experience",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.trainer_exp_gt || 0}</span>;
      },
    },
    {
      dataField: "trainer_category",
      text: "category",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.trainer_category || "NA"}</span>;
      },
    },
    {
      dataField: "city",
      text: "address",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.city || ""}, {row?.state || ""}, {row?.pin || ""}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 minWidth150"
            style={{
              background: row?.status === "active" ? "#379C00" : "#C90808",
              color: "#fff",
            }}
          >
            <small>{row?.status || "NA"}</small>
          </span>
        );
      },
    },
    {
      dataField: "pan_card",
      text: "pan card",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.pan_card ? (
              <a href={row.pan_card}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-cloud-arrow-down"
                  viewBox="0 0 16 16"
                  style={{
                    color: "#209216",
                    minWidth: "35px",
                    minHeight: "35px",
                  }}
                >
                  <path
                    fillRule="evenodd"
                    d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z"
                  />
                  <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                </svg>
              </a>
            ) : (
              <CrossCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "aadhar_card",
      text: "aadhar card",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.aadhar_card ? (
              <a href={row.aadhar_card}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-cloud-arrow-down"
                  viewBox="0 0 16 16"
                  style={{
                    color: "#209216",
                    minWidth: "35px",
                    minHeight: "35px",
                  }}
                >
                  <path
                    fillRule="evenodd"
                    d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z"
                  />
                  <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                </svg>
              </a>
            ) : (
              <CrossCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "shift_details",
      text: "shift details",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data link"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "shift_details",
                rowData: row,
              }))
            }
          >
            View
          </span>
        );
      },
    },
    {
      dataField: "trainer_expertise",
      text: "trainer expertise",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data link"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "trainer_expertise",
                rowData: row,
              }))
            }
          >
            View
          </span>
        );
      },
    },
  ];

  const shiftDetailsTbColumn = [
    {
      dataField: "shift_name",
      text: "shift name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.shift_name || "-"}</span>;
      },
    },
    {
      dataField: "start_time",
      text: "start time",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.start_time ? convertTo12HourFormat(row.start_time) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "end_time",
      text: "end time",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.end_time ? convertTo12HourFormat(row.end_time) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.date_added ? formattedLongDate2(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 minWidth100"
            style={{
              background: row?.status === "active" ? "#379C00" : "#C90808",
              color: "#fff",
            }}
          >
            <small>{row?.status || "NA"}</small>
          </span>
        );
      },
    },
  ];

  const expertiseTbColumn = [
    {
      dataField: "name",
      text: "name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.name || "-"}</span>;
      },
    },
    {
      dataField: "image",
      text: "image",
      formatter: (_, row) => (
        <div
          className="emeberDetailsRowContainer"
          style={{
            textAlign: "center",
            justifyContent: "center",
            gap: "1rem",
          }}
        >
          <img
            src={row?.image || BodyBuilder}
            alt={row?.name || "N/A"}
            className="image"
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "4px",
              border: "1px solid #000",
              padding: "10px",
              cursor: "pointer",
            }}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "trainer_expertise_image",
                rowData: row,
                image: row?.image || BodyBuilder,
                expertiseName: row?.name || "",
              }))
            }
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.modName === "member_checkin_details" ||
            modValues.modName === "trainer_profile" ||
            modValues.modName === "trainer_expertise" ||
            modValues.modName === "trainer_expertise_image"
              ? "mod-width-50p"
              : ""
          }`}
        >
          <ModalHeadAndClose
            title={` ${
              modValues.modName === "trainer_expertise_image"
                ? ""
                : modValues.modName?.replace(/_/g, " ")
            } ${
              modValues.modName === "shift_details" ||
              modValues.modName === "trainer_expertise" ||
              modValues.modName === "trainer_profile"
                ? ": " + modValues.rowData?.name
                : ""
            } ${
              modValues.modName === "trainer_expertise_image"
                ? modValues.expertiseName
                : ""
            }`}
            onClose={onCloseModal}
          />

          {modValues.modName === "member_checkin_details" ? (
            <MemberCheckinLogs
              clickValues={modValues}
              sendableStatsQPs={modValues.sendableStatsQPs}
              from={"fitness_center"}
            />
          ) : modValues.modName === "member_subscription_details" ? (
            <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table mt30">
              <PaymentLinkTable
                tableData={
                  modValues.rowData?.subscriptions?.length > 0
                    ? modValues.rowData.subscriptions
                    : []
                }
                tableColumns={subsTbColumn}
              />
            </div>
          ) : modValues.modName === "shift_details" ? (
            <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table mt30">
              <PaymentLinkTable
                tableData={
                  modValues.rowData?.shift_details?.length > 0
                    ? modValues.rowData.shift_details
                    : []
                }
                tableColumns={shiftDetailsTbColumn}
              />
            </div>
          ) : modValues.modName === "trainer_expertise" ? (
            <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table mt30">
              <PaymentLinkTable
                tableData={
                  modValues.rowData?.trainer_expertise?.length > 0
                    ? modValues.rowData.trainer_expertise
                    : []
                }
                tableColumns={expertiseTbColumn}
              />
            </div>
          ) : modValues.modName === "trainer_profile" ||
            modValues.modName === "trainer_expertise_image" ? (
            <div className="discussionModalMessage">
              <img
                src={modValues.image}
                alt="profile"
                style={{
                  width: "400px",
                  height: "400px",
                }}
              />
            </div>
          ) : null}
        </div>
      </Modal>

      <CmnFilters
        from={"gym-members"}
        userInfoData={userInfoData}
        onClickReset={onResetFilters}
        filters={allFilters}
        setFilters={setAllFilters}
        onClickSearch={onClickSearch}
        searchFilterApplied={searchFilterApplied}
        selectedTab={selectedTab}
      />

      <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table mt30">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allData}
            tableColumns={selectedTab === 1 ? tbTrainersColumns : tbColumns}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>
    </>
  );
};

export default GymMembers;
